<gh-dropdown [menuItems]="items" dropdownMenuClass="kr-options" iconName="ellipsis"></gh-dropdown>
